export const StatusBadge = ({ status }: { status: string }) => {
  const isEnabled = status === "Enabled";
  return (
    <span
      className={`enb-status-badge ${isEnabled ? "enb-status--enabled" : "enb-status--deenabled"}`}
    >
      {isEnabled ? "ENABLED" : "DE-ENABLED"}
    </span>
  );
};